export const ADD_CONTACT = 'ADD_CONTACT';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const LOAD_CONTACTS = 'LOAD_CONTACTS';
export const LOAD_CONTACT_CARD = 'LOAD_CONTACT_CARD';
export const CREATE_CONTACT_INVITE = 'CREATE_CONTACT_INVITE';
export const LOAD_CONTACT_INVITES = 'LOAD_CONTACT_INVITES';
export const UPDATE_CONTACT_INVITE = 'UPDATE_CONTACT_INVITE';

export function loadContactsAction(profileId) {
  return {
    type: LOAD_CONTACTS,
    payload: { profileId: profileId || null }
  };
}

export function loadContactCardAction(slug) {
  return {
    type: LOAD_CONTACT_CARD,
    payload: { slug }
  };
}

export function addContactAction(targetId) {
  return {
    type: ADD_CONTACT,
    payload: { targetId }
  };
}

export function deleteContactAction(contactId) {
  return {
    type: DELETE_CONTACT,
    payload: { contactId }
  };
}

export function loadContactInvitesAction(profileId) {
  return {
    type: LOAD_CONTACT_INVITES,
    payload: { profileId: profileId || null }
  };
}

export function createContactInviteAction(creator, target) {
  return {
    type: CREATE_CONTACT_INVITE,
    payload: { creator, target }
  };
}

export function updateContactInviteAction(id, status) {
  return {
    type: UPDATE_CONTACT_INVITE,
    payload: { status, id }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/contacts.actions.js